module.exports = __webpack_public_path__ + "img/about-4.f3ca4b39.png";